import { alpha } from '@mui/material';

export const PRIORITY_COLOR = {
    high: '#ef4444',
    medium: '#f59e0b',
    low: '#6366f1',
};

export const PRIORITY_BG = {
    high: alpha('#ef4444', 0.08),
    medium: alpha('#f59e0b', 0.08),
    low: alpha('#6366f1', 0.08),
};

export const SIGNAL_DEFINITIONS = [
    { key: 'has_question', label: 'Question (?)' },
    { key: 'has_emoji', label: 'Emoji' },
    { key: 'has_numbers', label: 'Numbers / Stats' },
    { key: 'has_hashtags', label: 'Hashtags (#)' },
    { key: 'has_cta', label: 'Call-to-Action' },
    { key: 'has_links', label: 'Links' },
];

export const FEATURE_CHIPS = [
    'Keyword Gaps',
    'Topic Coverage',
    'Engagement Signals',
    'Tone Analysis',
    'Recommendations',
];
